import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PaginatedDTO } from 'src/app/Common/common.interface';
import { ItemMaster_BulkUpsert, ItemMaster_Create, ItemMaster_CreateBulkViaExcel, ItemMaster_Delete, ItemMaster_ReadAll, ItemMaster_ReadAllPaginated, ItemMaster_ReadbyId, ItemMaster_SearchByName, ItemMaster_Update ,ItemMaster_UpdateBulkColumn } from 'src/app/GlobalVariables';
import {
    ItemMasterCreateBulkRequestDTO,
    ItemMasterCreateRequestDTO,
    ItemMasterDeleteRequestDTO,
    ItemMasterDTO,
    ItemMasterList,
    ItemMasterReadByIdRequestDTO,
    ItemMasterUpdateRequestDTO,
    ItemMasterUpdateBulkColumnRequestDTO,
    ItemMasterSearchByNamePostRequestDTO
} from './item-master/item-master.interface';



@Injectable({
    providedIn: 'root'
})
export class ItemMasterService {
    constructor(private http: HttpClient) { }

    ItemMaster_Create(data: ItemMasterCreateRequestDTO): Observable<ItemMasterDTO> {
        return this.http.post<ItemMasterDTO>(ItemMaster_Create, data);
    }

    ItemMaster_Update(data: ItemMasterUpdateRequestDTO): Observable<ItemMasterDTO> {
        return this.http.post<ItemMasterDTO>(ItemMaster_Update, data);
    }

    ItemMaster_Delete(data: ItemMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(ItemMaster_Delete, data);
    }

    ItemMaster_ReadbyId(data: ItemMasterReadByIdRequestDTO): Observable<ItemMasterDTO> {
        return this.http.post<ItemMasterDTO>(ItemMaster_ReadbyId, data);
    }

    ItemMaster_ReadAll(): Observable<ItemMasterList> {
        return this.http.get<ItemMasterList>(ItemMaster_ReadAll);
    }
    ItemMaster_ReadAllPaginated(data: PaginatedDTO): Observable<ItemMasterList> {
        return this.http.post<ItemMasterList>(ItemMaster_ReadAllPaginated, data);
    }

    ItemMaster_CreateBulkViaExcel(data: FormData): Observable<ItemMasterList> {
        return this.http.post<ItemMasterList>(ItemMaster_CreateBulkViaExcel, data);
    }

    ItemMaster_BulkUpsert(data: ItemMasterCreateBulkRequestDTO): Observable<ItemMasterList> {
        return this.http.post<ItemMasterList>(ItemMaster_BulkUpsert, data);
    }

    ItemMaster_UpdateBulkColumn(data: ItemMasterUpdateBulkColumnRequestDTO): Observable<ItemMasterDTO> {
       return this.http.post<ItemMasterDTO>(ItemMaster_UpdateBulkColumn, data); 
    }

    ItemMaster_SearchByName(data: ItemMasterSearchByNamePostRequestDTO):Observable<ItemMasterList>{
        return this.http.post<ItemMasterList>(ItemMaster_SearchByName , data);
    }
    

}
